export function asArray(value) {
  return Array.isArray(value) ? value : []
}

export function asCollection(value) {
  if (Array.isArray(value)) return value
  if (!value || typeof value !== 'object') return []
  if (Array.isArray(value.items)) return value.items
  if (Array.isArray(value.content)) return value.content
  return []
}